import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';
import {
  AccessControlResponse,
  SecurityGroupRequest,
} from '../types/securityGroup.types';
const PERMISSION_BASE_URL = `${BASE_URL}/permissions/api/v1`;

export const getAccessControlListData = async (
  securityGroupId: string
): Promise<AccessControlResponse> => {
  const {data} = await apiClient.get<AccessControlResponse>(
    `${PERMISSION_BASE_URL}/securitygroups/access-controls`,
    {
      params: {securityGroupId},
    }
  );
  return data;
};
export const SaveAccessControlList = async (
  payload: SecurityGroupRequest
): Promise<string> => {
  const response = await apiClient.post<string>(
    `${PERMISSION_BASE_URL}/securitygroups/access-controls`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
